import { Card, CardContent } from "@/components/ui/card";
import { ProgressCircle } from "@/components/ui/charts/progress-circle";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { mergeWithConfig } from "@/lib/dimensions";
import { FC } from "react";
import DimensionProgress from "./dimension-progress";
import ProgressSummarySkeleton from "./progress-summary-skeleton";

type ProgressSummaryCardProps = React.HTMLAttributes<HTMLDivElement> & {
  companyId: string;
  applicationQuizId: string;
};

const ProgressSummaryCard: FC<ProgressSummaryCardProps> = (props) => {
  const { data: quiz, isLoading: quizIsLoading } = useQuizById({
    companyId: props.companyId,
    applicationQuizId: props.applicationQuizId,
  });

  const summary = quiz?.summary;

  const dimensions = quiz?.dimensionsSummary.map(mergeWithConfig);

  if (quizIsLoading) {
    return <ProgressSummarySkeleton className={props.className} />;
  }

  return (
    <>
      {summary && (
        <Card className={props.className}>
          <CardContent className="pt-6">
            <h2 className="text-lg font-bold">Total del cuestionario</h2>

            <div className="my-4 flex items-center gap-4">
              <ProgressCircle
                value={summary.completedQuestionsPercentage}
                radius={38}
                strokeWidth={10}
                backgroundVariant="neutral"
              >
                <span className="text-xs font-medium text-[#8090A3]">
                  {summary.completedQuestionsPercentage}%
                </span>
              </ProgressCircle>

              <p>
                <strong className="text-sm">
                  {summary.completedQuestionsCount}/
                  {summary.totalQuestionsCount}
                </strong>
                <span className="block text-xs">Preguntas respondidas</span>
              </p>
            </div>

            <h2 className="my-4 text-xs font-bold text-[#293038]">
              Por dimensión
            </h2>

            <div className="flex flex-col gap-4">
              {dimensions?.map((dimension) => (
                <DimensionProgress
                  key={dimension.dimension}
                  percentage={dimension.completedPercentage}
                  color={dimension.color}
                  icon={dimension.icon}
                />
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default ProgressSummaryCard;
